import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const OAUTH_DOMAINS = ['idp.infocert.it', 'idpcl.infocert.it', 'idp.eu-south-1.tsaws.infocert.it'];

@Injectable()
export class HttpPayloadInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Non intercettare le richieste OAuth2/ISAC (token, jwks, discovery)
    if (OAUTH_DOMAINS.some(domain => req.url.includes(domain))) {
      return next.handle(req);
    }

    let body = req.body;

    if (
      req.body &&
      req.headers.get('Content-Type') === 'application/x-www-form-urlencoded'
    ) {
      body = new HttpParams({
        fromObject: req.body,
      }).toString();
    }

    if (req.urlWithParams.includes('/isac-oauth2/api/token')) {
      let formattedPayload = {};

      req.body.updates.forEach(update => {
        formattedPayload[update.param] = update.value;
      });

      body = new HttpParams({
        fromObject: formattedPayload,
      }).toString();
    }

    //console.log('HTTP', req.method, req.urlWithParams);

    const request = req.clone({
      body,
    });

    return next.handle(request);
  }
}
